<template>
	<div class="Ordercontent">
		<div class="list">
			<div class="couponList van-hairline--surround" v-for="item,index in couponList" v-show="couponList.length>0">
				<img src="./images/j2.png">
				<p class="title">奖品：{{item.drawName}}</p>
			</div>			
			<div class="info" v-show="couponList.length>0">有效期：永久</div>
			<div class="null" v-show="couponList.length<1">
				<p>暂无优惠券</p>
			</div>
		</div>
		<div style="margin: 16px;position: absolute;bottom: 30px;left: 50px;right: 50px;">
			<van-button round block color="linear-gradient(to right, #ff6034, #ee0a24)" class="cjBtn" @click="choujiang">
				前往抽奖
			</van-button>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import {
		Dialog
	} from 'vant';
	import {
		reqTurnrecord
	} from '../../api'
	export default {
		name: "stop",
		data() {
			return {
				userId: '',
				couponList: [],
			}
		},
		created() {
			this.userId = this.$cookies.get('userInfo').userId
			this.getCouponList()
		},
		mounted() {},
		methods: {
			//跳转地址选择
			gotoPath(path) {
				this.$router.push({
					path: path,
					name: path.substring(1),
				})
			},
			/*
			 * 点击切换tab，通过active的不同来获取对应数据
			 * */
			choujiang() {
				this.$router.push({
					path: "/choujiang",
					name: "choujiang"
				})
			},
			//列表
			getCouponList() {
				var data = {
					userId: this.userId
				}
				reqTurnrecord(data).then(res => {
					this.couponList = [];
					if (res.length > 0) {
						for(var i=0;i<res.length;i++){
							this.couponList.push(res[i]);
						}
					}
				})
				console.log(this.couponList.length);
			},
		}
	}
</script>

<style scoped>
	.null {
		text-align: center;
		padding-top: 30%;
	}

	.null p {
		font-size: 36px;
		color: #ccc;
	}
	.list{
		padding: 20px;
	}
	.info{
		text-align: center;
		color: #999;
		line-height: 50px;
	}
	.couponList{
		background-color: #fff;
		border-radius: 10px;
	}
	.couponList img{
		width: 120px;
		vertical-align: middle;
	}
	.couponList p{
		display: inline-block;
		font-size: 36px;
		color: #d03726;
		padding-left: 50px;
	}
	.cjBtn {
		height: 60px;
		line-height: 60px;
		font-size: 32px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/choujiang/list.vue